<div id="top-of-page"></div>
<app-back-header 
  [headerText]="'Torna ai preventivi'" 
  (backAction)="backToTable()" 
  class="sticky-top">
</app-back-header>

<div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
  <div>
    <h3 class="m-0">Nuovo preventivo</h3>
    <p class="m-0 text-muted">Clicca su una scheda per espanderne il contenuto</p>
  </div>
</div>

<!-- Main container for both cards -->
<div class="row mb-3 mb-md-2">
  <!-- First Card -->
  <div class="col-md-6 d-flex flex-column">
    <mat-card class="h-100 d-flex custom-card izy-sharp-bl">
      <mat-card-content class="h-100">
        <h5 class="mb-3">Seleziona cliente</h5>
        
        <!-- Main container-->
        <div class="h-100">
          <!-- Autocomplete with clear button container -->
          <div class="d-flex align-items-center gap-2 w-100">
            <!-- Autocomplete (takes most space) -->
            <div class="w-100">
              <app-company-autocomplete
                #companyAutocomplete
                [myControl]="myControl"
                (optionSelected)="onCompanySelected($event)"
              ></app-company-autocomplete>
            </div>

            <!-- Clear button (fixed width) -->
            <button
              *ngIf="myControl.value"
              mat-icon-button
              color="warn"
              (click)="clearCompanySelection()"
              type="button"
              class="mb-4 flex-shrink-0 custom-button-border"
              matTooltip="Cancella selezione cliente"
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <!-- Button Group -->
          <div class="w-sm-100 h-100">
            <div class="actions d-flex gap-2 w-100">
              <button
                mat-raised-button
                (click)="navigateToNewCompany()"
                class="w-sm-50-mobile-50 primary-button custom-button-border"
                matButton="filled"
                matTooltip="Registra un nuovo cliente."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                <mat-icon>person_add</mat-icon>
                <span>Nuovo</span>
              </button>
              <button
                mat-stroked-button
                (click)="openDialog()"
                class="w-sm-50-mobile-50 custom-button-border"
                matTooltip="Registra un nuovo cliente rapidamente, senza uscire dalla schermata."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                <mat-icon>bolt</mat-icon>
                <span class="hidden-mobile">Aggiunta rapida</span>
                <span class="visible-mobile">Rapido</span>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Second Card (company) - Desktop version -->
  <div class="col-md-6 d-flex flex-column">
    <mat-card class="h-100 mt-md-0 mt-3 custom-card izy-sharp-bl hidden-mobile">
      <mat-card-content class="h-100">
        <h5 class="mb-1">Cliente selezionato</h5>
        <!-- Add your content for the second card here -->
        <div class="d-flex flex-column h-100 justify-content-center">
          <div class="row">

            <!-- Show when no company is selected -->
            <div *ngIf="!newPreventive.company?.company_name" class="text-center text-muted py-4">
              <mat-icon class="mb-2">face</mat-icon>
              <p>Nessun cliente selezionato</p>
              <small>Seleziona un cliente dalla barra di ricerca</small>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newPreventive.company?.company_name" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Nome</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.company_name }}
                  </div>
                </div>
              </div>

              <div *ngIf="newPreventive.company?.iva_number" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Partita IVA</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.iva_number }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newPreventive.company?.address" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Indirizzo</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.address }}
                  </div>
                </div>
              </div>

              <div *ngIf="newPreventive.company?.addressee_code" class="company-details w-sm-50">
                <div class="mb-1">
                  <label class="form-label fw-bold text-secondary">Codice SDI</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.addressee_code }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Second Card (company) - Desktop version -->
  <div class="col-md-6 d-flex flex-column">
    <mat-expansion-panel
      class="h-100 mt-md-0 mt-3 custom-card izy-sharp-bl visible-mobile"
      #panelclient>
      <!-- <mat-card-content class="h-100"> -->
        <mat-expansion-panel-header>
          <mat-panel-title>
            Cliente
          </mat-panel-title>
          <mat-panel-description>
            {{ newPreventive.company?.company_name ? newPreventive.company?.company_name : 'Nessuno' }}
            <span class="panel-state">{{ panelclient.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- <h5 class="mb-3">Cliente selezionato</h5> -->

        <!-- Add your content for the second card here -->
        <div class="d-flex flex-column h-100 justify-content-center">
          <div class="row">
            
            <!-- Show when no company is selected -->
            <div *ngIf="!newPreventive.company?.company_name" class="text-center text-muted py-4">
              <mat-icon class="mb-2">face</mat-icon>
              <p>Nessun cliente selezionato</p>
              <small>Seleziona un cliente dalla barra di ricerca</small>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newPreventive.company?.company_name" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Nome</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.company_name }}
                  </div>
                </div>
              </div>

              <div *ngIf="newPreventive.company?.iva_number" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Partita IVA</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.iva_number }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Show when company is selected -->
              <div *ngIf="newPreventive.company?.address" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Indirizzo</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.address }}
                  </div>
                </div>
              </div>

              <div *ngIf="newPreventive.company?.addressee_code" class="company-details w-sm-50">
                <div class="mb-3">
                  <label class="form-label fw-bold text-secondary">Codice SDI</label>
                  <div class="p-2 bg-light rounded border">
                    {{ newPreventive.company?.addressee_code }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      <!-- </mat-card-content> -->
    </mat-expansion-panel>
  </div>

</div>

<!-- <mat-card class="mb-3 mb-md-2 col-md-5 d-flex flex-column custom-card">
  <mat-card-content class="h-100">
    <p>Cliente:</p>
    
  </mat-card-content>
</mat-card> -->

<div class="form-container">
  <form #preventiveForm="ngForm" (ngSubmit)="addNewElement()" class="preventive-form">

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      [expanded]="true"
      #stylepanel
    >

    <mat-expansion-panel-header>
      <mat-panel-title>
        Dati invio
      </mat-panel-title>
      <mat-panel-description>
        Validità: {{ formatValidityDate() }}
        <span class="panel-state">{{ stylepanel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

      <!-- <mat-card> -->
        <!-- <h5 class="mb-3">Dati documento</h5> -->

        <!-- <form #documentForm="ngForm" (ngSubmit)="addNewElement()" class="preventive-form"> -->
        <div class="row">
          <!-- <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Stile</mat-label>
            <mat-select
              [(ngModel)]="newPreventive.style"
              name="style"
              required
            >
              <mat-option
                *ngFor="let style of styleOptions"
                [value]="style.code"
              >
                {{ style.name }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Valido fino a</mat-label>
              <input
                matInput
                [matDatepicker]="validityDatePicker"
                [(ngModel)]="newPreventive.validity_date"
                name="validity_date"
                matTooltip="La data oltre la quale il preventivo non è più valido."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                required
              />
              <!-- (ngModelChange)="onEmissionDateChange($event)" -->
              <mat-datepicker-toggle
                matSuffix
                [for]="validityDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #validityDatePicker></mat-datepicker>
          </mat-form-field>

        </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      [expanded]="true"
      #panel
    >

    <mat-expansion-panel-header>
      <mat-panel-title>
        Preventivo
      </mat-panel-title>
      <mat-panel-description>
        Num. {{ newPreventive.preventives_progressive_number ? newPreventive.preventives_progressive_number : 'n' }}/{{ newPreventive.preventives_enumeration ? newPreventive.preventives_enumeration : 'Anno' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

      <!-- <mat-card> -->
        <!-- <h5 class="mb-3">Dati documento</h5> -->

        <!-- <form #documentForm="ngForm" (ngSubmit)="addNewElement()" class="preventive-form"> -->
        <div class="row">
          <!-- <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nome preventivo</mat-label>
            <input
              matInput
              [(ngModel)]="newPreventive.invoice_name"
              name="invoice_name"
              required
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Numero progressivo</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newPreventive.preventives_progressive_number"
              name="progressive_number"
              matTooltip="Numero progressivo del preventivo."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Numerazione</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newPreventive.enumeration"
              name="enumeration"
              matTooltip="La numerazione è importante. Ricorda di indicare in questo campo l'anno di riferimento."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Valuta</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newPreventive.currency"
              name="currency"
              required
            >
              <mat-option
                *ngFor="let currency of currencyOptions"
                [value]="currency.code"
              >
                {{ currency.code }} - {{ currency.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Lingua</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newPreventive.language"
              name="language"
              required
            >
              <mat-option
                *ngFor="let language of languageOptions"
                [value]="language.code"
              >
                {{ language.name }}
              </mat-option>
            </mat-select>
            <!-- <input
        matInput
        [(ngModel)]="newPreventive.language"
        name="language"
      /> -->
          </mat-form-field>

          <!-- ATECO Code Dropdown -->
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Seleziona Codice ATECO</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newPreventive.ateco_code_id"
              name="ateco_code_id"
              (selectionChange)="onAtecoCodeChange($event)"
              matTooltip="Seleziona il codice ATECO di riferimento fra quelli disponibili."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              [disabled]="isLoading">
              
              <!-- Loading state -->
              <mat-option *ngIf="isLoading" disabled>
                <div style="display: flex; align-items: center;">
                  <mat-spinner diameter="20" style="margin-right: 8px;"></mat-spinner>
                  Caricamento...
                </div>
              </mat-option>
              
              <!-- No codes available -->
              <mat-option *ngIf="!isLoading && atecoCodes.length === 0" disabled>
                Nessun codice ATECO disponibile
              </mat-option>
              
              <!-- ATECO code options -->
              <mat-option 
                *ngFor="let atecoCode of atecoCodes" 
                [value]="atecoCode.id">
                {{ atecoCode.ateco_division }}.{{ atecoCode.ateco_class }}.{{ atecoCode.ateco_subcategory }} - {{ atecoCode.name }}
              </mat-option>
            </mat-select>
            
            <!-- Loading hint -->
            <mat-hint *ngIf="isLoading">Caricamento codici ATECO...</mat-hint>
            <mat-hint *ngIf="!isLoading && atecoCodes.length > 0">
              {{ atecoCodes.length }} codici disponibili
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Descrizione/Oggetto preventivo</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="6"
              type="string"
              [(ngModel)]="newPreventive.description"
              name="description"
              matTooltip="Questa è la causale del tuo documento. Indica, sinteticamente, che tipo di prestazione offri."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            ></textarea>
          </mat-form-field>
          
        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Note (opzionali)</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="6"
              type="string"
              [(ngModel)]="newPreventive.notes"
              name="notes"
              matTooltip="Queste annotazioni appariranno in fondo al documento in PDF."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            ></textarea>
          </mat-form-field>
        
        </div>  
      <!-- </mat-card> -->
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      #panel2
    >
      <!-- <mat-card-content> -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          Fatturazione
        </mat-panel-title>
        <mat-panel-description>
          Emesso: {{ formatEmissionDate() }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

        <!-- <h5 class="mb-3">Fatturazione elettronica</h5> -->
        <!-- <form #preventiveForm="ngForm" (ngSubmit)="addNewElement()" class="preventive-form"> -->

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Tipo documento</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newPreventive.document_type"
              name="document_type"
              matTooltip="Il tipo di documento che stai per generare."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            >
              <mat-option
                *ngFor="let method of documentTypeOptions"
                [value]="method.code"
              >
                {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Metodo di pagamento</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newPreventive.payment_method"
              name="payment_method"
              matTooltip="Qui indichi come preferisci essere pagato/a."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            >
              <mat-option
                *ngFor="let method of paymentMethodOptions"
                [value]="method.code"
              >
                {{ method.code }} - {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>IBAN</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4"
              [(ngModel)]="newPreventive.iban"
              name="iban"
              matTooltip="Indica un IBAN sul quale desideri ricevere il pagamento, se il metodo di pagamento scelto lo prevede."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            ></textarea>
          </mat-form-field>

        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Data di emissione</mat-label>
            <input
              matInput
              [matDatepicker]="emissionDatePicker"
              [(ngModel)]="newPreventive.emission_date"
              name="emission_date"
              matTooltip="La data di emissione del preventivo."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
            <!-- (ngModelChange)="onEmissionDateChange($event)" -->
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Termini di pagamento (giorni)</mat-label>
            <input
              matInput
              type="number"
              min="0"
              max="1000"
              [(ngModel)]="newPreventive.payment_days"
              name="payment_days"
              matTooltip="Fra quanti giorni vuoi che il tuo cliente paghi? Qui puoi indicare (in giorni) un intervallo e l'App calcolerà la data di pagamento (prevista) in automatico."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Codice destinatario</mat-label>
            <input
              matInput
              [(ngModel)]="newPreventive.addressee_code"
              name="addresse_code"
              matTooltip="Questo è il codice SDI del tuo cliente. Viene impostato in automatico in base alla tua anagrafica, ma puoi eventualmente modificarlo qui."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            />
          </mat-form-field>
          <!-- <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Nome destinatario</mat-label>
            <input
              matInput
              [(ngModel)]="newPreventive.addressee_name"
              name="addresse_name"
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Esigibilità IVA</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newPreventive.iva_collectability"
              name="iva_collectability"
              required
              disabled
            >
              <mat-option
                *ngFor="let method of ivaCollectabilityOptions"
                [value]="method.code"
              >
                {{ method.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          
        </div>

        <div class="row">
          <div class="w-sm-25">
            <mat-slide-toggle
              [(ngModel)]="newPreventive.p_a"
              name="p_a"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onPaToggleChange($event)"
              matTooltip="Fattura per Pubblica Amministrazione."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Pubblica Amministrazione
            </mat-slide-toggle>
          </div>

          <div class="w-sm-25">
            <mat-slide-toggle
              [checked]="revenueStampOption === 'customer'"
              name="revenueStampCustomer"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onRevenueStampCustomerChange($event)"
              matTooltip="Marca da bollo a carico del cliente."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Bollo a carico del cliente
            </mat-slide-toggle>
          </div>

          <div class="w-sm-25">
            <mat-slide-toggle
              [checked]="revenueStampOption === 'me'"
              name="revenueStampMe"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onRevenueStampMeChange($event)"
              matTooltip="Marca da bollo a tuo carico."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Marca da bollo a tuo carico
            </mat-slide-toggle>
          </div>

          <div class="w-sm-25">
            <mat-slide-toggle
              [(ngModel)]="newPreventive.healthcare_invoice"
              name="healthcare_invoice"
              color="primary"
              class="mt-2 toggle-spacing"
              (change)="onHealthcareToggleChange($event)"
              matTooltip="Fattura prestazione sanitaria."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              Fattura prestazione sanitaria
            </mat-slide-toggle>
          </div>

          <!-- <mat-form-field appearance="outline" class="mt-md-0 mt-3 w-sm-25">
            <mat-label>Marca da bollo</mat-label>
            <input
              matInput
              [(ngModel)]="newPreventive.revenue_stamp"
              (ngModelChange)="onRevenueStampChange($event)"
              name="revenue_stamp"
            />
          </mat-form-field> -->
        </div>

        <!-- </form> -->
      <!-- </mat-card-content> -->
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      #panel3
    >
      <!-- <mat-card-content class="d-flex flex-column"> -->
        <mat-expansion-panel-header>
          <mat-panel-title>
            Prestazioni
          </mat-panel-title>
          <mat-panel-description>
            Aggiunte: <span class="article-badge">{{ numero_articoli }}</span>
            <span class="panel-state">{{ panel3.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- <h5 #productsList>Prodotti e servizi:</h5> -->

        <!-- List of added products/services -->
        <mat-card
          *ngFor="let item of productServices; let i = index"
          class="mb-2 izy-item-card product-card izy-sharp-bl"
        >
          <mat-card-content>
            <div class="izy-item-card__row">
              <div class="izy-item-card__body">
                <div class="izy-item-card__heading">
                  <span class="izy-item-card__title">{{ item.name }}</span>
                  <span class="izy-item-card__meta">
                    {{ item.quantity }} {{ item.units }}
                  </span>
                </div>
                <div class="izy-item-card__amount">
                  {{ formatCardAmount(item?.final_amount) }}
                  <span class="izy-item-card__amount-note">
                    di cui IVA {{ formatCardAmount(item.iva_amount) }}
                  </span>
                </div>
                <p *ngIf="item.description" class="izy-item-card__description">
                  <i>{{ item.description }}</i>
                </p>
              </div>
              <button
                mat-icon-button
                color="warn"
                (click)="removeProductService(i)"
                type="button"
                class="custom-button-border izy-item-card__remove"
                matTooltip="Rimuovi questa voce dal preventivo."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Autocomplete -->
        <div class="mt-3">
          <p>Cerca fra le prestazioni salvate:</p>
          
          <app-savedproduct-autocomplete
            [productControl]="productControl"
            (optionSelected)="onSavedProductSelected($event)"
          >
          </app-savedproduct-autocomplete>
        </div>

        <!-- Form to add new product/service -->
        <form
          #productServiceForm="ngForm"
          (ngSubmit)="addNewProductService(productServiceForm)"
          class="product-service-form d-flex flex-column"
        >
          <p>Oppure aggiungi un nuovo prodotto/servizio:</p>

          <div class="row">
            <mat-form-field appearance="outline" class="w-sm-50">
              <mat-label>Nome voce</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="6"
                [(ngModel)]="newProductService.name"
                name="name"
                required
                (change)="calculateFinalAmount()"
                matTooltip="Il nome della prestazione che vuoi inserire nel preventivo."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Quantità</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.quantity"
                name="quantity"
                required
                (change)="calculateFinalAmount()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Unità di misura</mat-label>
              <input
                matInput
                [(ngModel)]="newProductService.units"
                name="units"
                (change)="calculateFinalAmount()"
              />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Prezzo unitario</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.gross_amount"
                name="gross_amount"
                matTooltip="Prezzo per ogni singola unità. L'App calcolerà il totale in automatico."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                required
                (change)="calculateFinalAmount()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Sconto (%):</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.discount"
                name="discount"
                (change)="calculateFinalAmount()"
                matTooltip="Usa questo campo per calcolare in automatico uno sconto percentuale sul totale della prestazione."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>IVA (%):</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.iva_percentage"
                name="iva_percentage"
                (change)="calculateFinalAmount()"
                disabled
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
              <mat-label>Totale</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="newProductService.final_amount"
                name="final_amount"
                required
                (change)="calculateFinalAmount()"
                matTooltip="Totale dovuto per questa prestazione (il calcolo viene effettuato in automatico)."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
                readonly
              />
            </mat-form-field>
          </div>

          <div class="row">

            <mat-form-field appearance="outline" class="w-sm-50">
              <mat-label>Descrizione (opzionale)</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="6"
                [(ngModel)]="newProductService.description"
                name="description"
                (change)="calculateFinalAmount()"
                matTooltip="Aggiungi una descrizione opzionale, per permettere al tuo cliente di comprendere al meglio cosa stai inserendo nel preventivo."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              ></textarea>
            </mat-form-field>
          </div>

          <button
            mat-raised-button
            color="primary"
            type="submit"
            (click)="scrollToProductList()"
            [disabled]="!productServiceForm.valid"
            matButton="filled"
            class="mt-2 align-self-end primary-button custom-button-border"
            matTooltip="Aggiungi questa prestazione al preventivo."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
          <mat-icon>add_task</mat-icon>
            Aggiungi voce
          </button>
        </form>
      <!-- </mat-card-content> -->
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      #panel4
    >
    <!-- <mat-card-content class="d-flex flex-column"> -->
      <mat-expansion-panel-header>
          <mat-panel-title>
            Contributi
          </mat-panel-title>
          <mat-panel-description>
            Aggiunti: <span class="withholding-badge">{{ numero_contributi }}</span>
            <span class="panel-state">{{ panel4.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
      <!-- <h5 #taxwithholdingsList>Contributi e ritenute:</h5> -->

          <!-- List of added tax withholdings -->
          <mat-card
            *ngFor="let item of taxWithholdings; let i = index"
            class="mb-2 izy-item-card taxwithholding-card izy-sharp-bl"
          >
            <mat-card-content>
              <div class="izy-item-card__row">
                <div class="izy-item-card__body">
                  <div class="izy-item-card__heading">
                    <span class="izy-item-card__title">{{ item.kind }}</span>
                    <span class="izy-item-card__meta">
                      {{ item.rate_percentage }}% su {{ item.total_percentage }}%
                    </span>
                  </div>
                  <div class="izy-item-card__amount">
                    {{ formatCardAmount(item.rate_amount) }}
                  </div>
                  <p *ngIf="item.details" class="izy-item-card__description">
                    <i>{{ item.details }}</i>
                  </p>
                </div>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="removeTaxWithholding(i)"
                  type="button"
                  class="custom-button-border izy-item-card__remove"
                  matTooltip="Rimuovi questo contributo dal preventivo."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Form to add new tax withholding -->
          <form
            #taxWithholdingForm="ngForm"
            (ngSubmit)="addNewTaxWithholding()"
            class="tax-withholding-form d-flex flex-column"
          >
            <p>Aggiungi contributo o ritenuta:</p>

            <div class="row">
              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Tipo</mat-label>
                <mat-select
                  class="izy-select-trigger"
                  panelClass="izy-select-panel izy-select-panel--form"
                  [(ngModel)]="newTaxWithholding.kind"
                  name="kind"
                  required
                  [disabled]="getAvailableKinds().length === 0"
                  matTooltip="La tipologia di voce che stai inserendo. Ricorda che puoi inserire un solo valore per ogni tipo."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <!-- Show warning when all kinds are used -->
                  <mat-option *ngIf="getAvailableKinds().length === 0" disabled>
                    Tutti i tipi sono già stati aggiunti
                  </mat-option>
                  
                  <!-- Show available kinds -->
                  <mat-option
                    *ngFor="let kind of getAvailableKinds()"
                    [value]="kind.code"
                  >
                    {{ kind.name }}
                    <span *ngIf="isKindAlreadyUsed(kind.code)" class="text-muted">
                      (già presente)
                    </span>
                  </mat-option>
                </mat-select>
                
                <!-- Hint about limitations -->
                <mat-hint *ngIf="getAvailableKinds().length > 0">
                  {{ getAvailableKinds().length }} tipi disponibili
                </mat-hint>
                <mat-hint *ngIf="getAvailableKinds().length === 0" class="text-warning">
                  Hai già aggiunto tutti i tipi disponibili
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Percentuale (%)</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="newTaxWithholding.rate_percentage"
                  name="rate_percentage"
                  required
                  (change)="calculateTaxWithholdingTotal()"
                  [disabled]="isKindAlreadyUsed(newTaxWithholding.kind)"
                  matTooltip="La percentuale da calcolare sull'imponibile."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Su imponibile (%)</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="newTaxWithholding.total_percentage"
                  name="total_percentage"
                  required
                  [disabled]="isKindAlreadyUsed(newTaxWithholding.kind)"
                />
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-sm-25">
                <mat-label>Valore (€)</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="newTaxWithholding.rate_amount"
                  name="rate_amount"
                  matTooltip="Questo valore viene calcolato in automatico in base alle percentuali inserite."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                  required
                  readonly
                />
              </mat-form-field>
            </div>

            <div class="row">            
              <mat-form-field appearance="outline" class="w-sm-50">
                <mat-label>Dettagli (opzionali)</mat-label>
                <textarea
                  matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="6"
                  [(ngModel)]="newTaxWithholding.details"
                  name="details"
                  [disabled]="isKindAlreadyUsed(newTaxWithholding.kind)"
                ></textarea>
              </mat-form-field>

              <!-- Show pension fund only when 'Cassa' is selected -->
              <mat-form-field 
                appearance="outline" 
                class="w-sm-50"
                *ngIf="newTaxWithholding.kind === 'CASSA'"
              >
                <mat-label>Cassa previdenziale</mat-label>
                <mat-select
                  class="izy-select-trigger"
                  panelClass="izy-select-panel izy-select-panel--form"
                  [(ngModel)]="newPreventive.pension_fund_type"
                  name="pension_fund_type"
                  matTooltip="Seleziona la cassa previdenziale di riferimento."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  <mat-option
                    *ngFor="let pension_fund of pensionFundOptions"
                    [value]="pension_fund.code"
                  >
                    {{ pension_fund.code }} - {{ pension_fund.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>

            <!-- Warning message -->
            <div *ngIf="isKindAlreadyUsed(newTaxWithholding.kind)" class="alert alert-warning mt-2 d-grid align-items-center" style="grid-template-columns: auto 1fr; gap: 8px;">
              <mat-icon class="me-2">warning</mat-icon>
              Hai già aggiunto una {{ getKindDisplayName(newTaxWithholding.kind) }}. 
              Puoi averne solo una per tipo.
            </div>

            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!taxWithholdingForm.valid || isKindAlreadyUsed(newTaxWithholding.kind)"
              matButton="filled"
              class="mt-2 align-self-end primary-button custom-button-border"
            >
              <mat-icon>post_add</mat-icon>
              Aggiungi contributo/ritenuta
            </button>
          </form>
        <!-- </mat-card-content> -->
      </mat-expansion-panel>

    <mat-card class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl">
      <mat-card-content class="d-flex flex-column">
        <h4 class="m-2">Riepilogo preventivo:</h4>
        <p class="ms-2 small text-muted">{{ newPreventive.document_type }} - {{ getDocumentTypeName(newPreventive.document_type!) }}</p>

        <!-- Totale prestazioni -->
        <div class="d-flex justify-content-between align-items-center m-2">
          <span>Totale prestazioni ({{ numero_articoli }} articoli):</span>
          <span class="fw-medium">{{ formatCardAmount(preventive_gross_amount, newPreventive.currency) }}</span>
        </div>

        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center m-2">
          <span class="fw-medium"> Sconto:</span>
          <span class="fw-medium">- {{ formatCardAmount(preventive_discount_amount, newPreventive.currency) }}</span>
        </div>

        <!-- Marca da bollo -->
        <div *ngIf="revenueStampOption === 'customer'">
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Marca da bollo:</span>
            <span>+{{ formatCardAmount(preventive_revenue_stamp, newPreventive.currency) }}</span>
          </div>
        </div>

        <!-- Competenze -->
        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center m-2">
          <span class="fw-medium">Competenze:</span>
          <span class="fw-medium">{{ formatCardAmount((preventive_total_amount + preventive_revenue_stamp), newPreventive.currency) }}</span>
        </div>

        <!-- Rivalsa -->
        <div *ngIf="hasTaxWithholdingsOfKind('RIVALSA')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Rivalsa:</span>
            <span>{{ formatCardAmount(rivalsa_total, newPreventive.currency) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center ms-2 me-2">
            <span class="small text-muted">Totale con rivalsa:</span>
            <span class="small text-muted">{{ formatCardAmount(preventive_total_amount_with_rivalsa, newPreventive.currency) }}</span>
          </div>
        </div>

        <!-- Cassa -->
        <div *ngIf="hasTaxWithholdingsOfKind('CASSA')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Cassa:</span>
            <span>{{ formatCardAmount(cassa_total, newPreventive.currency) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center ms-2 me-2">
            <span class="small text-muted">Imponibile:</span>
            <span class="small text-muted">{{ formatCardAmount(total_taxable, newPreventive.currency) }}</span>
          </div>
        </div>

        <!-- IVA -->
        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center m-2">
          <span>IVA:</span>
          <span>{{ formatCardAmount(preventive_iva_amount, newPreventive.currency) }}</span>
        </div>

        <!-- Ritenuta d'acconto -->
        <div *ngIf="hasTaxWithholdingsOfKind('RITENUTA_ACCONTO')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Ritenuta d'acconto:</span>
            <span>-{{ formatCardAmount(ritenuta_acconto_total, newPreventive.currency) }}</span>
          </div>
        </div>

        <!-- Ritenute -->
        <div *ngIf="hasTaxWithholdingsOfKind('RITENUTA')">
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between align-items-center m-2">
            <span>Ritenute:</span>
            <span>-{{ formatCardAmount(ritenuta_total, newPreventive.currency) }}</span>
          </div>
        </div>

        <!-- Totale da incassare -->
        <mat-divider></mat-divider>
        <div class="d-flex justify-content-between align-items-center summary-item total">
          <span class="fw-bold h5 mt-2 ms-1">Totale da incassare:</span>
          <span class="fw-bold h5 mt-2 me-1">{{ formatCardAmount(preventive_total_paid_amount, newPreventive.currency) }}</span>
        </div>

        <div class="d-flex align-self-end">
          <!-- <button
            mat-stroked-button
            color="primary"
            type="button"
            [disabled]="!preventiveForm.valid"
            class="mt-3 me-3"
            (click)="downloadPreventivePdf(newPreventive.id)"
          >
            <mat-icon>print</mat-icon>
            Vedi PDF
          </button> -->

          <!-- desktop version -->
          <div class="d-flex align-self-end hidden-mobile">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="!preventiveForm.valid || numero_articoli === 0 || newPreventive.company_id === 0 "
              class="mt-3 me-3 custom-button-border"
              (click)="addNewElement(undefined, true)"
              matTooltip="Visualizza l'anteprima con lo stile da te impostato."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <mat-icon>visibility</mat-icon>
              Anteprima
            </button>
            <button
              mat-raised-button
              matButton="filled"
              type="button"
              [disabled]="!preventiveForm.valid || numero_articoli === 0 || newPreventive.company_id === 0"
              class="mt-3 me-0 primary-button custom-button-border"
              (click)="addNewElement()"
              matTooltip="Salva il preventivo."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <mat-icon>save</mat-icon>
              Salva preventivo
            </button>
          </div>
          <!-- mobile version -->
            <div class="d-flex visible-mobile mt-2">
              <div class="container-fluid p-0">
                <!-- First row with Preview and Save buttons -->
                <div class="row g-2 mb-2">
                  <div class="col-12">
                      <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        [disabled]="!preventiveForm.valid || numero_articoli === 0 || newPreventive.company_id === 0"
                        class="w-100 mt-3 me-3 custom-button-border"
                        (click)="addNewElement(undefined, true)"
                        matTooltip="Visualizza l'anteprima con lo stile da te impostato."
                        [matTooltipShowDelay]="showDelay.value"
                        [matTooltipHideDelay]="hideDelay.value"
                      >
                        <mat-icon>visibility</mat-icon>
                        Anteprima
                      </button>
                    </div>
                    <div class="col-12">
                      <button
                        mat-raised-button
                        matButton="filled"
                        type="button"
                        [disabled]="!preventiveForm.valid || numero_articoli === 0 || newPreventive.company_id === 0"
                        class="w-100 mt-2 me-3 primary-button custom-button-border"
                        (click)="addNewElement()"
                        matTooltip="Salva il preventivo."
                        [matTooltipShowDelay]="showDelay.value"
                        [matTooltipHideDelay]="hideDelay.value"
                      >
                        <mat-icon>save</mat-icon>
                        Salva preventivo
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

      </mat-card-content>
    </mat-card>
  </form>
</div>

<div class="pt-3 mb-3"></div>
